import { ParentBase, ChildWithParents } from 'types';

export const mergeChildrenWithParentsIntoParents = (childrenWithParents: ChildWithParents[]) =>
    childrenWithParents.reduce<ParentBase[]>(
        (allParents, currentChild) => allParents.concat(currentChild.parents),
        [],
    );
